import { message } from "antd";
import axios from "axios";
import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import httpUtil from "../../utils/http.util";
import { MsgLoading, MsgSuccess } from "../Loaders/MessageLoaders";
// import './TextEditor.less';
// import { serverUrl } from '@/utils/constant';
// import request from '@/utils/request';
const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "code",
  "color",
  "background",
  "code-block",
  "align",
  "clean",
];

interface OnChangeHandler {
  (e: any): void;
}

type Props = {
  value: string;
  placeholder: string;
  onChange: OnChangeHandler;
};

const TextEditor: React.FC<Props> = ({ value, onChange, placeholder }) => {
  const reactQuillRef: any = useRef(null);
  const imageHandler = async () => {
    const input: any = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.setAttribute("multiple", "multiple");
    input.click();
    input.onchange = async () => {
      Array.from(input.files).forEach((item: any) => {
        const formData = new FormData();
        formData.append("img", item);
        // formData.append('subjectId', '123');,
        console.log(item, formData, "file to be uploaded >>>>");
        const data = {
          img: item,
        };
        MsgLoading();
        httpUtil.post("/upload/img", formData).then(({ data }) => {
          console.log("data", data);
          const quill = reactQuillRef?.current?.getEditor();
          const cursorPosition = quill.getSelection().index;
          const link = data.path;
          console.log(quill.insertEmbed);
          MsgSuccess("Img uploaded successfully!");
          quill.insertEmbed(cursorPosition, "image", link);
          quill.setSelection(cursorPosition + 1);
        });
      });
    };
  };

  const modules = React.useMemo(
    () => ({
      toolbar: {
        container: [
          // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          ["link", "image"],
          [{ color: [] }, { background: [] }, { align: [] }],
          ["clean"],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    []
  );

  return (
    <>
      <ReactQuill
        ref={reactQuillRef}
        theme="snow"
        value={value || ""}
        modules={modules}
        formats={formats}
        onChange={onChange}
        placeholder={placeholder}
      />
    </>
  );
};

export default TextEditor;
